import {without} from 'lodash';

import {PreferencesModel} from '../../../models/api/preferencesModel';
import {AppAction} from '../../appActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {TagsActionsEnum} from '../tags/tagsActions';

export function preferencesReducer(state: PreferencesModel, action: AppAction): PreferencesModel {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED: {
      const {preferences} = action.payload.result;
      if (!preferences) {
        return state;
      }

      if (!action.payload.shouldIgnoreUpdatedAt && state.updatedAt > preferences.updatedAt) {
        return state;
      }

      return preferences;
    }

    case TagsActionsEnum.TAG_DELETION_CONFIRMED:
      return {
        ...state,
        visibleCustomViewIds: without(state.visibleCustomViewIds, action.payload),
      };

    default:
      return state;
  }
}
